module.exports = __webpack_public_path__ + "media/common/fonts/template/template-d7203a8c6125a3b6d280013c63bb3676.ttf";